import React from "react";
import { SimpleShowLayout } from "react-admin";

import SessionExamProfessor from "./SessionExamProfessor";
import { SectionTitle } from "features/SectionTitle";

const SessionExamProfessorsInfo = ({ record }) => {
  return (
    <>
      <SectionTitle
        title="Преподаватели"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <SimpleShowLayout>{record && <SessionExamProfessor record={record} />}</SimpleShowLayout>
    </>
  );
};

export default SessionExamProfessorsInfo;
